// avisosHorarioConfig.js — ESPEJO del cuerpo de aws_lambdas/_shared_autoescuela/avisosHorarioConfig.js (7/10/2026,
// Autoescuela Poveda): horario de mañana a los profesores y plazo de confirmación. Lo de entre las marcas lo escribe
// `node aws_lambdas/_shared_autoescuela/avisosHorarioCopias.js`; avisosHorarioCopias.test.js vigila que no diverja.
/* eslint-disable */
// ── avisosHorarioConfig: cuerpo compartido (inicio) ──
const HORARIO_MANANA_DEFAULTS = Object.freeze({ enabled: false, hora: "20:00", dias: Object.freeze([1, 2, 3, 4, 5, 6]) });
const HORA_ENVIO_MIN = "07:00";
const HORA_ENVIO_MAX = "22:30";
/** Horas que se pueden elegir: de 07:00 a 22:30, cada media hora (el cron pasa a :00 y :30). */
const HORAS_ENVIO = (() => {
  const out = [];
  for (let m = 7 * 60; m <= 22 * 60 + 30; m += 30) out.push(`${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`);
  return Object.freeze(out);
})();
const HORARIO_MANANA_KEYS = ["enabled", "hora", "dias"];

// `desde` (27/10/2026, Autoescuela Carian): "practica" = el plazo vence `horas` ANTES de la práctica (lo de siempre,
// de fábrica); "envio" = vence `horas` DESPUÉS de enviarle la propuesta con botones (`semana_envio_at`), p. ej. «24 h
// para contestar», también tras «Volver a pedir confirmación» (que no cambia el envío).
const PLAZO_DEFAULTS = Object.freeze({ enabled: false, horas: 24, accion: "avisar", desde: "practica" });
const PLAZO_HORAS_MIN = 2;
const PLAZO_HORAS_MAX = 168;
/** Las del desplegable (cualquier entero entre 2 y 168 vale igual). */
const PLAZO_HORAS_OPCIONES = Object.freeze([2, 3, 4, 6, 8, 12, 18, 24, 36, 48, 72]);
const PLAZO_ACCIONES = Object.freeze(["avisar", "liberar"]);
const PLAZO_DESDE = Object.freeze(["practica", "envio"]);
const PLAZO_KEYS = ["enabled", "horas", "accion", "desde"];

const esObjeto = (v) => !!v && typeof v === "object" && !Array.isArray(v);

/** Valida lo que manda el front al guardar. @returns {{value}|{error}} */
function validaHorarioManana(raw) {
  if (!esObjeto(raw)) return { error: "horario_manana_profesores debe ser un objeto" };
  const desconocidas = Object.keys(raw).filter((k) => !HORARIO_MANANA_KEYS.includes(k));
  if (desconocidas.length) return { error: `horario_manana_profesores: campos desconocidos: ${desconocidas.join(", ")}` };
  if (raw.enabled !== undefined && typeof raw.enabled !== "boolean") return { error: "horario_manana_profesores.enabled debe ser booleano" };
  const hora = raw.hora === undefined ? HORARIO_MANANA_DEFAULTS.hora : raw.hora;
  if (!HORAS_ENVIO.includes(hora)) return { error: `horario_manana_profesores.hora debe ser una hora en punto o y media entre ${HORA_ENVIO_MIN} y ${HORA_ENVIO_MAX}` };
  const dias = raw.dias === undefined ? [...HORARIO_MANANA_DEFAULTS.dias] : raw.dias;
  if (!Array.isArray(dias) || dias.some((d) => !Number.isInteger(d) || d < 0 || d > 6)) {
    return { error: "horario_manana_profesores.dias debe ser una lista de días de la semana (0 = domingo … 6 = sábado)" };
  }
  return { value: { enabled: raw.enabled === true, hora, dias: [...new Set(dias)].sort((a, b) => a - b) } };
}

/** Lo guardado, listo para usar. Cualquier cosa rara → lo de fábrica; solo `enabled === true` enciende. */
function normalizaHorarioManana(raw) {
  const r = validaHorarioManana(esObjeto(raw) ? raw : {});
  if (r.error) {
    const o = esObjeto(raw) ? raw : {};
    return {
      enabled: o.enabled === true,
      hora: HORAS_ENVIO.includes(o.hora) ? o.hora : HORARIO_MANANA_DEFAULTS.hora,
      dias: Array.isArray(o.dias) && o.dias.every((d) => Number.isInteger(d) && d >= 0 && d <= 6)
        ? [...new Set(o.dias)].sort((a, b) => a - b) : [...HORARIO_MANANA_DEFAULTS.dias],
    };
  }
  return r.value;
}

/** Valida lo que manda el front al guardar. @returns {{value}|{error}} */
function validaPlazoConfirmacion(raw) {
  if (!esObjeto(raw)) return { error: "plazo_confirmacion debe ser un objeto" };
  const desconocidas = Object.keys(raw).filter((k) => !PLAZO_KEYS.includes(k));
  if (desconocidas.length) return { error: `plazo_confirmacion: campos desconocidos: ${desconocidas.join(", ")}` };
  if (raw.enabled !== undefined && typeof raw.enabled !== "boolean") return { error: "plazo_confirmacion.enabled debe ser booleano" };
  const horas = raw.horas === undefined ? PLAZO_DEFAULTS.horas : raw.horas;
  if (!Number.isInteger(horas) || horas < PLAZO_HORAS_MIN || horas > PLAZO_HORAS_MAX) {
    return { error: `plazo_confirmacion.horas debe ser un entero entre ${PLAZO_HORAS_MIN} y ${PLAZO_HORAS_MAX}` };
  }
  const accion = raw.accion === undefined ? PLAZO_DEFAULTS.accion : raw.accion;
  if (!PLAZO_ACCIONES.includes(accion)) return { error: "plazo_confirmacion.accion debe ser 'avisar' o 'liberar'" };
  const desde = raw.desde === undefined ? PLAZO_DEFAULTS.desde : raw.desde;
  if (!PLAZO_DESDE.includes(desde)) return { error: "plazo_confirmacion.desde debe ser 'practica' o 'envio'" };
  return { value: { enabled: raw.enabled === true, horas, accion, desde } };
}

/** Lo guardado, listo para usar. Cualquier cosa rara → lo de fábrica; solo `enabled === true` enciende. */
function normalizaPlazo(raw) {
  const o = esObjeto(raw) ? raw : {};
  return {
    enabled: o.enabled === true,
    horas: Number.isInteger(o.horas) && o.horas >= PLAZO_HORAS_MIN && o.horas <= PLAZO_HORAS_MAX ? o.horas : PLAZO_DEFAULTS.horas,
    // Ante la duda, lo que no toca la práctica.
    accion: o.accion === "liberar" ? "liberar" : "avisar",
    // Ausente o raro = lo de siempre (antes de la práctica).
    desde: o.desde === "envio" ? "envio" : "practica",
  };
}

// repetir_confirmacion (26/10/2026, Autoescola Garrotxa): { enabled, horas, veces, desde, hasta } — si `horas` después
// de enviarle la planificación con botones (semana o práctica asignada) el alumno no ha contestado NADA a ese envío, se
// le vuelve a pedir que confirme (plantilla practicas_sin_confirmar_crm), como mucho `veces` por envío, solo entre
// `desde` y `hasta` (hora de Madrid; fuera de la franja se aplaza a la siguiente pasada dentro de ella).
// Ficha: docs/features/autoescuela-repetir-confirmacion-planificacion.md
const REPETIR_DEFAULTS = Object.freeze({ enabled: false, horas: 12, veces: 1, desde: "09:00", hasta: "21:00" });
const REPETIR_HORAS_MIN = 2;
const REPETIR_HORAS_MAX = 72;
/** Las del desplegable (cualquier entero entre 2 y 72 vale igual). */
const REPETIR_HORAS_OPCIONES = Object.freeze([2, 3, 4, 6, 8, 12, 18, 24, 36, 48]);
const REPETIR_VECES_MAX = 3;
const REPETIR_KEYS = ["enabled", "horas", "veces", "desde", "hasta"];

/** Valida lo que manda el front al guardar. @returns {{value}|{error}} */
function validaRepetirConfirmacion(raw) {
  if (!esObjeto(raw)) return { error: "repetir_confirmacion debe ser un objeto" };
  const desconocidas = Object.keys(raw).filter((k) => !REPETIR_KEYS.includes(k));
  if (desconocidas.length) return { error: `repetir_confirmacion: campos desconocidos: ${desconocidas.join(", ")}` };
  if (raw.enabled !== undefined && typeof raw.enabled !== "boolean") return { error: "repetir_confirmacion.enabled debe ser booleano" };
  const horas = raw.horas === undefined ? REPETIR_DEFAULTS.horas : raw.horas;
  if (!Number.isInteger(horas) || horas < REPETIR_HORAS_MIN || horas > REPETIR_HORAS_MAX) {
    return { error: `repetir_confirmacion.horas debe ser un entero entre ${REPETIR_HORAS_MIN} y ${REPETIR_HORAS_MAX}` };
  }
  const veces = raw.veces === undefined ? REPETIR_DEFAULTS.veces : raw.veces;
  if (!Number.isInteger(veces) || veces < 1 || veces > REPETIR_VECES_MAX) {
    return { error: `repetir_confirmacion.veces debe ser un entero entre 1 y ${REPETIR_VECES_MAX}` };
  }
  const desde = raw.desde === undefined ? REPETIR_DEFAULTS.desde : raw.desde;
  const hasta = raw.hasta === undefined ? REPETIR_DEFAULTS.hasta : raw.hasta;
  if (!HORAS_ENVIO.includes(desde) || !HORAS_ENVIO.includes(hasta)) {
    return { error: `repetir_confirmacion.desde y .hasta deben ser horas en punto o y media entre ${HORA_ENVIO_MIN} y ${HORA_ENVIO_MAX}` };
  }
  if (desde >= hasta) return { error: "repetir_confirmacion.desde debe ser anterior a .hasta" };
  return { value: { enabled: raw.enabled === true, horas, veces, desde, hasta } };
}

/** Lo guardado, listo para usar. Cualquier cosa rara → lo de fábrica; solo `enabled === true` enciende. */
function normalizaRepetir(raw) {
  const o = esObjeto(raw) ? raw : {};
  const r = validaRepetirConfirmacion({
    enabled: o.enabled === true,
    horas: Number.isInteger(o.horas) && o.horas >= REPETIR_HORAS_MIN && o.horas <= REPETIR_HORAS_MAX ? o.horas : REPETIR_DEFAULTS.horas,
    veces: Number.isInteger(o.veces) && o.veces >= 1 && o.veces <= REPETIR_VECES_MAX ? o.veces : REPETIR_DEFAULTS.veces,
    desde: HORAS_ENVIO.includes(o.desde) ? o.desde : REPETIR_DEFAULTS.desde,
    hasta: HORAS_ENVIO.includes(o.hasta) ? o.hasta : REPETIR_DEFAULTS.hasta,
  });
  // Franja al revés (desde ≥ hasta): la de fábrica, nunca «a cualquier hora».
  return r.value || { enabled: o.enabled === true, horas: REPETIR_DEFAULTS.horas, veces: REPETIR_DEFAULTS.veces, desde: REPETIR_DEFAULTS.desde, hasta: REPETIR_DEFAULTS.hasta };
}
// ── avisosHorarioConfig: cuerpo compartido (fin) ──

export {
  HORARIO_MANANA_DEFAULTS, HORAS_ENVIO, HORA_ENVIO_MIN, HORA_ENVIO_MAX, validaHorarioManana, normalizaHorarioManana,
  PLAZO_DEFAULTS, PLAZO_HORAS_MIN, PLAZO_HORAS_MAX, PLAZO_HORAS_OPCIONES, PLAZO_ACCIONES, PLAZO_DESDE, validaPlazoConfirmacion, normalizaPlazo,
  REPETIR_DEFAULTS, REPETIR_HORAS_MIN, REPETIR_HORAS_MAX, REPETIR_HORAS_OPCIONES, REPETIR_VECES_MAX, validaRepetirConfirmacion, normalizaRepetir,
};
